import React, { useState } from 'react';
import Overview from './Overview';
import ShotList from './ShotList';
import Moodboard from './Moodboard';
import Logistics from './Logistics';
import { activeProject } from '../../data/mockData';

const ProjectCommand = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'OVERVIEW' },
    { id: 'shotlist', label: 'SHOT LIST' },
    { id: 'moodboard', label: 'MOODBOARD' },
    { id: 'logistics', label: 'LOGISTICS' },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'overview': return <Overview />;
      case 'shotlist': return <ShotList />;
      case 'moodboard': return <Moodboard />;
      case 'logistics': return <Logistics />;
      default: return <Overview />;
    }
  };

  return (
    <div className="max-w-7xl mx-auto">
      {/* Header Area */}
      <div className="mb-8 flex flex-col md:flex-row md:items-end justify-between gap-4 border-b border-[#222] pb-6">
        <div>
           <div className="flex items-center gap-2 mb-2">
             <span className="w-2 h-2 bg-pink-500 rounded-full animate-pulse shadow-[0_0_8px_rgba(236,72,153,0.8)]"></span>
             <span className="font-mono text-[10px] text-pink-500 tracking-widest uppercase">Live Session</span>
             <span className="font-mono text-[10px] text-[#555] mx-2">/</span>
             <span className="font-mono text-[10px] text-[#888] tracking-widest">{activeProject.id}</span>
           </div>
           <h1 className="text-4xl md:text-5xl font-black text-white tracking-tighter uppercase">
             Command Center
           </h1>
        </div>

        {/* Custom Tab Navigation */}
        <div className="flex overflow-x-auto hide-scrollbar gap-1 bg-[#111] p-1 border border-[#222]">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-6 py-2 font-mono text-xs uppercase tracking-widest transition-all whitespace-nowrap
                ${activeTab === tab.id 
                  ? 'bg-[#222] text-white border-b-2 border-pink-500' 
                  : 'text-[#666] hover:text-[#aaa] hover:bg-[#1a1a1a] border-b-2 border-transparent'
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content Area */}
      <div className="min-h-[60vh]">
        {renderContent()}
      </div>
    </div>
  );
};

export default ProjectCommand;